export default __webpack_public_path__ + "static/media/project-todo.afff3266.PNG";